
import { useState, useEffect, useCallback, useRef } from 'react';
import { Pedido, OrderStatus } from '../types';
import { pedidosService } from '../services/pedidos.service';

export const usePedidos = (empresaId?: string) => {
  const [pedidos, setPedidos] = useState<Pedido[]>([]);
  const [loading, setLoading] = useState(true);
  const soundRef = useRef(new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3'));

  const loadPedidos = useCallback(async (isInitial = false) => {
    if (!empresaId) return;
    try {
      const data = await pedidosService.getPedidos(empresaId);
      setPedidos(prev => {
        if (!isInitial) {
          const hasNew = data.some(p => p.status === OrderStatus.NOVO && !prev.find(old => old.id === p.id));
          if (hasNew) soundRef.current.play().catch(() => {});
        }
        return data;
      });
    } catch (err) {
      console.error("Erro ao carregar pedidos:", err);
    } finally {
      setLoading(false);
    }
  }, [empresaId]);

  useEffect(() => {
    if (!empresaId) return;
    loadPedidos(true);
    const channel = pedidosService.subscribePedidos(empresaId, () => loadPedidos());
    const interval = setInterval(() => loadPedidos(), 30000);
    
    return () => {
      channel.unsubscribe();
      clearInterval(interval);
    };
  }, [empresaId, loadPedidos]);

  return { pedidos, loading, reload: loadPedidos };
};
